import { useSistema } from 'features/carrello/hooks';
import { formatPrice, formatValueByDivisor } from 'features/carrello/utils';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { memo } from 'react';
import styles from './CarrelloCombinazioniContent.module.scss';

export type CarrelloCombinazioniContentProps = {
  idSistema: string;
  currency?: string;
};

export const CarrelloCombinazioniContent = memo(function CarrelloCombinazioniContent({
  idSistema,
  currency = 'EUR',
}: CarrelloCombinazioniContentProps) {
  const labelImportoTotale = useGetLabelByKey('importo-totale-giocato');
  const labelPossibileVincita = useGetLabelByKey('possibile-vincita-carrello');

  const { importo, possibileVincitaMin } = useSistema(idSistema) ?? {};

  const formatValue = (value: number) => {
    const formattedValueByDivisor = formatValueByDivisor(value ?? 0, 100).toFixed(2);
    return formatPrice(formattedValueByDivisor);
  };

  return (
    <ul className={styles.list}>
      <li className={styles.item}>
        <span className={styles.label}>{labelImportoTotale}</span>
        <span className={styles.labelBold}>
          {formatValue(importo ?? 0)} {currency}
        </span>
      </li>
      <li className={styles.item}>
        <span className={styles.label}>{labelPossibileVincita}</span>
        <p className={styles.labelBig}>
          Min{' '}
          <span className={styles.labelBold}>
            {formatValue(possibileVincitaMin ?? 0)} {currency}
          </span>
        </p>
      </li>
    </ul>
  );
});
